import { createStyles, makeStyles } from '@material-ui/core/styles';
import { globalColors } from './globalColorVariables';

const useDialogStyles = makeStyles(() =>
  createStyles({
    dialogPaper: {
      borderRadius: '28px',
      maxWidth: '750px'
    },
    dialogClose: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    dialogContent: {
      textAlign: 'center',
      ' & div': {
        margin: '1rem 0'
      }
    },
    description: {
      whiteSpace: 'pre-line'
    },
    imgDiv: {
      display: 'flex',
      justifyContent: 'center'
    },
    nlBtn: {
      borderRadius: '20px',
      backgroundColor: '#2864AC',
      fontWeight: 500,
      color: '#fff',
      ' &:hover': {
        backgroundColor: '#2864AC'
      }
    },
    learnBtn: {
      color: '#2864AC',
      textDecoration: 'none',
      fontWeight: 500
    }
  })
);

export default useDialogStyles;
